import { useMemo } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LeistungsgebieteHero from './components/LeistungsgebieteHero';
import CityGrid from './components/CityGrid';
import SEO from '../../components/feature/SEO';
import JsonLd from '../../components/feature/JsonLd';

export default function LeistungsgebietePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://igm-baudienste.com';

  const jsonLdData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${siteUrl}/leistungsgebiete`,
        'url': `${siteUrl}/leistungsgebiete`,
        'name': 'Leistungsgebiete | IGM Facility Service – NRW & Rhein-Ruhr',
        'description': 'IGM Facility Service ist in 12 Städten der Region Rhein-Ruhr tätig: Ratingen, Düsseldorf, Mönchengladbach, Wuppertal, Hagen, Mettmann, Velbert, Solingen, Remscheid, Erkrath, Hilden und Langenfeld.',
        'isPartOf': { '@id': `${siteUrl}/#website` },
      },
      {
        '@type': 'LocalBusiness',
        '@id': `${siteUrl}/#business`,
        'name': 'IGM Facility Service',
        'url': siteUrl,
        'telephone': '+4921027398070',
        'email': 'kontakt@igmfacilityservice.de',
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': 'Industriestr. 37',
          'addressLocality': 'Ratingen',
          'postalCode': '40878',
          'addressCountry': 'DE',
        },
        'areaServed': [
          { '@type': 'City', 'name': 'Ratingen' },
          { '@type': 'City', 'name': 'Düsseldorf' },
          { '@type': 'City', 'name': 'Mönchengladbach' },
          { '@type': 'City', 'name': 'Wuppertal' },
          { '@type': 'City', 'name': 'Hagen' },
          { '@type': 'City', 'name': 'Mettmann' },
          { '@type': 'City', 'name': 'Velbert' },
          { '@type': 'City', 'name': 'Solingen' },
          { '@type': 'City', 'name': 'Remscheid' },
          { '@type': 'City', 'name': 'Erkrath' },
          { '@type': 'City', 'name': 'Hilden' },
          { '@type': 'City', 'name': 'Langenfeld' },
        ],
      },
      {
        '@type': 'BreadcrumbList',
        'itemListElement': [
          { '@type': 'ListItem', 'position': 1, 'name': 'Home', 'item': siteUrl },
          { '@type': 'ListItem', 'position': 2, 'name': 'Leistungsgebiete', 'item': `${siteUrl}/leistungsgebiete` },
        ],
      },
    ],
  }), [siteUrl]);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO
        title="Leistungsgebiete | IGM Facility Service – Düsseldorf, Mönchengladbach, Hagen & NRW"
        description="IGM Facility Service tätig in Ratingen, Düsseldorf, Mönchengladbach, Wuppertal, Hagen & 7 weiteren Städten in NRW. Gebäudereinigung, Facility Management & Renovierung. Jetzt Angebot anfragen!"
        keywords="Gebäudereinigung Düsseldorf, Facility Service NRW, Reinigung Mönchengladbach, Gebäudereinigung Hagen, IGM Ratingen Leistungsgebiet"
        canonical={`${siteUrl}/leistungsgebiete`}
      />
      <JsonLd data={jsonLdData} id="json-ld-leistungsgebiete" />
      <Navbar />
      <LeistungsgebieteHero />
      <CityGrid />
      <Footer />
    </div>
  );
}
